import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../global/global.service';
import { ResponseStructure } from '@iq-central-front-end/share';
import Swal from 'sweetalert2';

@Component({
  selector: 'iq-central-front-end-add-lesson',
  templateUrl: './add-lesson.component.html',
  styleUrls: ['./add-lesson.component.scss'],
})
export class AddLessonComponent implements OnInit, OnDestroy, AfterViewInit {
  sub: Subscription = new Subscription();
  @ViewChild('lessonName') lessonName: ElementRef;
  isLoading: boolean;
  lessonForm: FormGroup;
  lessons: any[] = [];
  courseCode: any;
  lessonId: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _course: CourseService,
    private fb: FormBuilder,
    private _global: GlobalService
  ) {}

  ngOnInit(): void {
    this.initLessonForm();
    this.courseCode = this.route.snapshot.paramMap.get('code');
    this.route.data.subscribe((res) => {
      this.lessons = res['resolvedData'].responseResult;
    });
  }
  ngAfterViewInit() {
    this.lessonName.nativeElement.focus();
  }
  initLessonForm() {
    this.lessonForm = this.fb.group({
      title: ['', Validators.required],
    });
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  addLessonContent(route?) {
    if (!route) {
      this.isLoading = true;
    }
    const payload = this.lessonForm.value;
    payload.courseCode = this.courseCode;
    this.sub.add(
      this._course.createLesson(payload).subscribe({
        next: (res: ResponseStructure) => {
          this.lessonId = res.responseResult['id'];
          this.isLoading = false;
          if (route) {
            this._global.hideSpinner();
            this.router.navigate(['courses']);
          } else {
            this.router.navigate([
              'courses/select-lesson-type',
              this.lessonId,
              this.courseCode,
            ]);
          }
        },
      })
    );
  }
  finish(route) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This lesson will be saved and you will be taken to your courses',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1CB4AE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.value) {
        this._global.showSpinner();
        this.addLessonContent(route);
      }
    });
  }
  addContent(id) {
    this.router.navigate(['courses/select-lesson-type', id, this.courseCode]);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
